export enum MutationTypes {
  SET_INCIDENTS = "incident-events/set-incidents",
  SET_INCIDENTS_META = "incident-events/set-incidents-meta",
  SET_INCIDENTS_COUNT = "incident-events/set-incidents-count",
  SET_INCIDENTS_TYPES = "incidents-module/fetch-incidents-types",
  SET_INCIDENTS_TYPES_FOR_FILTER = "incidents-module/fetch-incidents-types-for-filter",
}
